import { min as minFns } from 'date-fns';

export default function min(dates: Date[]): Date {
  return minFns(dates);
}
